<template>
  <Expandable
    class="mb-4 rounded-md border mt-4"
    v-bind="$attrs"
    :expandable-id="rule.id"
    v-on="$listeners"
  >
    <template #expandable-title>
      <div>
        {{ rule.name  || 'Unnamed Rule' }}
        {{ getRequisitesCreditsRangeLabel(relatedRequisites, [rule]) }}
      </div>
    </template>
    <template #expandable-content>
      <div class="p-4 border-t">
        <div
          v-if="rule.description && rule.description !== '<p></p>'"
          class="mt-2"
        >
          <RichContent
            class="reset-liststyle text-base md:text-lg"
            :content="rule.description"
          />
        </div>
        <BaseIcon
          icon="graduation-cap"
          class="cap-icon"
          aria-hidden="true"
        />
        <span class="color-deep-black font-bold rule-name text-base md:text-lg leading-5 md:leading-6">{{ displayString }}</span>
        <template v-if="rules && rules.length">
          <ExpandableController :expanded="$attrs.expanded">
            <template #expand-button><span /></template>
            <template #default="{ expandables:expandablesSubRule, trackToggle:trackToggleSubRule }">
              <div
                v-for="(subRule, index) in rules"
                :key="`subRule-${index}`"
              >
                <div v-if="index > 0" class="rule-divider">
                  <span class="divider-text">{{ getDividerText() }}</span>
                </div>
                <RequisitesSimpleRule
                  :rule="subRule"
                  :related-requisites="relatedRequisites"
                  class="mt-1 ml-5"
                  :expandable-id="`subrule-${index}`"
                  :expanded="`subrule-${index}` in expandablesSubRule ? expandablesSubRule[`subrule-${index}`] : $attrs.expanded"
                  @toggle="trackToggleSubRule({ expandableId: `subrule-${index}`, expandableStatus: $event })"
                  @showModal="$emit('showModal', $event)"
                />
              </div>
            </template>
          </ExpandableController>
        </template>
        <RequisiteSimpleDataSelect
          v-else-if="shouldShowDataSelect"
          :related-requisites="relatedRequisites"
          :selection="rule.value || {}"
          class="pl-5 pt-1"
          @showModal="$emit('showModal', $event)"
        />
        <div
          v-if="rule.notes && rule.notes !== '<p></p>'"
          class="mt-4"
        >
          <RichContent
            class="reset-liststyle text-base md:text-lg"
            :content="rule.notes"
          />
        </div>
      </div>
    </template>
  </Expandable>
</template>

<script>
import RequisitesSimpleRuleDefaults from '../RequisitesSimpleRuleDefaults'
import RequisiteSimpleDataSelect from './RequisiteSimpleDataSelect'
import RichContent from '@/components/RichContent'
import Expandable from '@/components/Expandable'
import ExpandableController from '@/components/ExpandableController'

export default {
  components: {
    RequisiteSimpleDataSelect,
    RichContent,
    Expandable,
    ExpandableController,
  },
  ...RequisitesSimpleRuleDefaults,
  inheritAttrs: false,
  methods: {
    getDividerText() {
      const condition = this.rule.condition
      if (condition === 'allOf') return 'AND'
      return 'OR'
    }
  }
}
</script>

<style scoped>
.toggle-icon {
  width: 1rem;
  height: 1rem;
}
.cap-icon {
  display: inline;
  position: relative;
  top: -0.1rem;
  min-width: 1rem;
}

.rule-divider {
  position: relative;
  height: 20px;
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rule-divider::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 1px;
  background-color: #d1d5db;
}

.divider-text {
  background-color: white;
  padding: 0 15px;
  font-weight: 600;
  font-size: 12px;
  color: #6b7280;
  z-index: 1;
  position: relative;
}
</style>
